import RmSetUploadIntervalModal from './rm-set-upload-interval-modal.vue'
export default RmSetUploadIntervalModal
